import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, finalize, tap } from 'rxjs/operators';
import { api_base_url } from 'src/app/shared/api/api_url';
import { AccountService } from 'src/app/shared/services/custom/account.service';
import { AdminService } from 'src/app/shared/services/custom/admin.service';
import { StoreService } from 'src/app/shared/services/store.service';

declare let $;

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss'],
  styles: [`.toggle-password {
		position: absolute;
    	right: 7px;
    	top: 11px;
		z-index: 10;
		cursor: pointer;
	}`]
})
export class AdminPageComponent {
  loginForm: FormGroup;
  loading = false;
  isPasswordReset;
  //isAccountConfirm;
  constructor(private fb: FormBuilder, private account: AccountService, public store : StoreService,
    private http : HttpClient, private router : Router) {
      this.loginForm = this.fb.group({
          'username': [null, Validators.required],
          'password': [null, Validators.required]
      });
  }

  togglePassword(ev) {
      $(ev.target).toggleClass("fa-eye fa-eye-slash");
      var input = $(ev.target).prev();
      if (input.attr("type") == "password") {
          input.attr("type", "text");
      } else {
          input.attr("type", "password");
      }
  }

  submit() {
      this.loginForm.markAllAsTouched();
      if (this.loginForm.invalid || this.loading)
          return;
      this.loading = true;
      let data = this.loginForm.value;
      this.http.post(api_base_url + 'Token', data).pipe(
        finalize(() => {
          this.loading = false;
        }),
        tap((user:any) => {
          localStorage.setItem('userdata', JSON.stringify(user));
          this.account.user$.next(user);
        }),
        tap(user => {
          this.account.showPrices$.next(true);
        }),
      ).subscribe(r => {
        this.router.navigateByUrl('admin/preview');
      }, error => {
        if (error.error) {
          let jsonError = error.error;
          if (error.status == 403) {
              if (jsonError.error_code == 1452005) {
                  this.loginForm.get('username').setErrors({
                      'emailNotExist': `Utente con email "${data['username']}" non esiste`
                  });
                  return;
              }
              if (jsonError.error_code == 1452008) {
                  this.loginForm.get('password').setErrors({
                      'passwordWrong': `Password errata`
                  });
                  return;
              }
              if (jsonError.error_code == 3) {
                this.loginForm.get('username').setErrors({
                    'emailNotExist': `Utente "${data['username']}" non esiste o password errata`
                });
                return;
              }

              if (jsonError.error_code == 2) {
                  this.loginForm.get('password').setErrors({
                      'passwordWrong': `Password errata`
                  });
                  return;
              }
              if (jsonError.error_code == -1) {
                this.loginForm.get('username').setErrors({
                  'notAdmin': `Questo utente non è amministratore`
                });
                return;
              }
          }
        }
        alert(JSON.stringify(error));
      });
  }

  /**
  * Checking control validation
  *
  * @param controlName: string => Equals to formControlName
  * @param validationType: string => Equals to valitors name
  */
  isControlHasError(controlName: string): boolean | string {
      const control = this.loginForm.controls[controlName];
      if (!control || !control.touched) {
          return false;
      }
      if (control.errors) {
          if (control.errors['required']) {
              return 'Il campo è obbligatorio';
          }
          if (control.errors['email'])
              return 'Email non è valido';
          if (control.errors['emailNotExist'])
              return control.errors['emailNotExist'];
          if (control.errors['passwordWrong'])
              return control.errors['passwordWrong'];
          if (control.errors['notAdmin'])
              return control.errors['notAdmin'];

          return 'Errore nella compilazione del campo';
      }
      return false;
  }
}
